// This file is auto-generated by @hey-api/openapi-ts

import { client, type Options } from '@hey-api/client-fetch';
import type {
  GetEcomTransactionData,
  GetEcomTransactionError,
  GetEcomTransactionResponse,
  PutEcomTransactionData,
  PutEcomTransactionError,
  PutEcomTransactionResponse,
  DeleteEcomTransactionData,
  DeleteEcomTransactionError,
  DeleteEcomTransactionResponse,
  AddOrUpdatePolicyData,
  AddOrUpdatePolicyError,
  AddOrUpdatePolicyResponse,
  GetBlockedSkusError,
  GetBlockedSkusResponse,
  CreatedOrUpdateBlockedSkuData,
  CreatedOrUpdateBlockedSkuError,
  CreatedOrUpdateBlockedSkuResponse,
  ListTrialSkusError,
  ListTrialSkusResponse,
  PostTrialSkuData,
  PostTrialSkuError,
  PostTrialSkuResponse,
  PostEcomTransactionData,
  PostEcomTransactionError,
  PostEcomTransactionResponse,
  GetSkuFeatureMappingData,
  GetSkuFeatureMappingError,
  GetSkuFeatureMappingResponse,
  PostSkuFeatureMappingData,
  PostSkuFeatureMappingError,
  PostSkuFeatureMappingResponse,
  DeleteSkuFeatureMappingData,
  DeleteSkuFeatureMappingError,
  DeleteSkuFeatureMappingResponse,
  UpdateSkuFeatureMappingData,
  UpdateSkuFeatureMappingError,
  UpdateSkuFeatureMappingResponse,
  CreateInvitationData,
  CreateInvitationError,
  CreateInvitationResponse,
  ApplyInvitationKeyData,
  ApplyInvitationKeyError,
  ApplyInvitationKeyResponse,
  CreateEntitlementData,
  CreateEntitlementError,
  CreateEntitlementResponse,
  GetBulkAccessData,
  GetBulkAccessError,
  GetBulkAccessResponse,
  ListActivationsData,
  ListActivationsError,
  ListActivationsResponse,
  PostUserActivationData,
  PostUserActivationError,
  PostUserActivationResponse,
  CreateActivationRequestData,
  CreateActivationRequestError,
  CreateActivationRequestResponse,
  ListAccountsData,
  ListAccountsError,
  ListAccountsResponse,
  CreateAccountData,
  CreateAccountError,
  CreateAccountResponse,
  ExportAccountUsersData,
  ExportAccountUsersError,
  ExportAccountUsersResponse,
  ExportAccountProjectsData,
  ExportAccountProjectsError,
  ExportAccountProjectsResponse,
  GetAccountAdminsData,
  GetAccountAdminsError,
  GetAccountAdminsResponse,
  AddAccountAdminsData,
  AddAccountAdminsError,
  AddAccountAdminsResponse,
  ActivateAccountData,
  ActivateAccountError,
  ActivateAccountResponse,
  CheckContextAccessInBulkData,
  CheckContextAccessInBulkError,
  CheckContextAccessInBulkResponse,
  GetAccountDetailsData,
  GetAccountDetailsError,
  GetAccountDetailsResponse,
  UpdateAccountData,
  UpdateAccountError,
  UpdateAccountResponse,
  GetUserAccountsData,
  GetUserAccountsError,
  GetUserAccountsResponse,
  ListUsagesData,
  ListUsagesError,
  ListUsagesResponse,
  GetTrialSkuData,
  GetTrialSkuError,
  GetTrialSkuResponse,
  DeleteTrialSkuData,
  DeleteTrialSkuError,
  DeleteTrialSkuResponse,
  ListSkuFeatureMappingsError,
  ListSkuFeatureMappingsResponse,
  GetProjectEntitlementData,
  GetProjectEntitlementError,
  GetProjectEntitlementResponse,
  GetProjectAccountDtoData,
  GetProjectAccountDtoError,
  GetProjectAccountDtoResponse,
  GetPolicyByIdData,
  GetPolicyByIdError,
  GetPolicyByIdResponse,
  ListMyInvitationsData,
  ListMyInvitationsError,
  ListMyInvitationsResponse,
  GetMyAccountsData,
  GetMyAccountsError,
  GetMyAccountsResponse,
  GetInvitationData,
  GetInvitationError,
  GetInvitationResponse,
  DeleteInvitationData,
  DeleteInvitationError,
  DeleteInvitationResponse,
  ListInvitationsData,
  ListInvitationsError,
  ListInvitationsResponse,
  GetFeatureAccessData,
  GetFeatureAccessError,
  GetFeatureAccessResponse,
  GetExportDetailsData,
  GetExportDetailsError,
  GetExportDetailsResponse,
  GetEntitlementData,
  GetEntitlementError,
  GetEntitlementResponse,
  DeleteEntitlementData,
  DeleteEntitlementError,
  DeleteEntitlementResponse,
  ListUsersData,
  ListUsersError,
  ListUsersResponse,
  ListFeaturesData,
  ListFeaturesError,
  ListFeaturesResponse,
  ListProjectsData,
  ListProjectsError,
  ListProjectsResponse,
  GetBlockedSkuData,
  GetBlockedSkuError,
  GetBlockedSkuResponse,
  GetActivationData,
  GetActivationError,
  GetActivationResponse,
  DeleteUserActivationData,
  DeleteUserActivationError,
  DeleteUserActivationResponse,
  GetActivationRequestData,
  GetActivationRequestError,
  GetActivationRequestResponse,
  GetUsersInAccountData,
  GetUsersInAccountError,
  GetUsersInAccountResponse,
  GetUserActivationsInAccountData,
  GetUserActivationsInAccountError,
  GetUserActivationsInAccountResponse,
  RemoveAccountUserData,
  RemoveAccountUserError,
  RemoveAccountUserResponse,
  ListAccountUserProjectsData,
  ListAccountUserProjectsError,
  ListAccountUserProjectsResponse,
  GetAccountUsageData,
  GetAccountUsageError,
  GetAccountUsageResponse,
  GetProjectsInAccountData,
  GetProjectsInAccountError,
  GetProjectsInAccountResponse,
  ListAccountUsersData,
  ListAccountUsersError,
  ListAccountUsersResponse,
  FetchAccountProjectUserMappingData,
  FetchAccountProjectUserMappingError,
  FetchAccountProjectUserMappingResponse,
  ListAccountInvitationsData,
  ListAccountInvitationsError,
  ListAccountInvitationsResponse,
  ListEntitlementsData,
  ListEntitlementsError,
  ListEntitlementsResponse,
  ListActivationRequestData,
  ListActivationRequestError,
  ListActivationRequestResponse,
  GetAccessPolicyData,
  GetAccessPolicyError,
  GetAccessPolicyResponse,
  RemoveAccountAdminsData,
  RemoveAccountAdminsError,
  RemoveAccountAdminsResponse,
} from './types.gen';

/**
 * Get EcomTransaction
 * Fetch the transaction details by transaction id.<br/>This API will work for user with site admin access as well as the transaction created by or modified by user.
 */
export const getEcomTransaction = (
  options: Options<GetEcomTransactionData>
) => {
  return (options?.client ?? client).get<
    GetEcomTransactionResponse,
    GetEcomTransactionError
  >({
    ...options,
    url: '/transactions/{id}',
  });
};

/**
 * Update EcomTransaction
 * Update the transaction status and count by transaction id.<br/>This API will work for user with site admin access as well as the transaction created by or modified by user.
 */
export const putEcomTransaction = (
  options: Options<PutEcomTransactionData>
) => {
  return (options?.client ?? client).put<
    PutEcomTransactionResponse,
    PutEcomTransactionError
  >({
    ...options,
    url: '/transactions/{id}',
  });
};

/**
 * Delete EcomTransaction
 * Set the created or running status transaction as CANCELLED based on transaction id.<br/>This API will work for user with site admin access as well as the transaction created by or modified by user.
 */
export const deleteEcomTransaction = (
  options: Options<DeleteEcomTransactionData>
) => {
  return (options?.client ?? client).delete<
    DeleteEcomTransactionResponse,
    DeleteEcomTransactionError
  >({
    ...options,
    url: '/transactions/{id}',
  });
};

/**
 * Create or Update a Policy
 * This API is used to create and update policies. It is only accessible for `Site Admin`. Only the requested features and applications will be saved for the given policy. The features list cannot be empty. The application must already be registered with an application ID.
 */
export const addOrUpdatePolicy = (options: Options<AddOrUpdatePolicyData>) => {
  return (options?.client ?? client).put<
    AddOrUpdatePolicyResponse,
    AddOrUpdatePolicyError
  >({
    ...options,
    url: '/policies',
  });
};

export const getBlockedSkus = (options?: Options) => {
  return (options?.client ?? client).get<
    GetBlockedSkusResponse,
    GetBlockedSkusError
  >({
    ...options,
    url: '/block-skus',
  });
};

export const createdOrUpdateBlockedSku = (
  options: Options<CreatedOrUpdateBlockedSkuData>
) => {
  return (options?.client ?? client).put<
    CreatedOrUpdateBlockedSkuResponse,
    CreatedOrUpdateBlockedSkuError
  >({
    ...options,
    url: '/block-skus',
  });
};

/**
 * List TrialSkus
 * List all skus from trial list. This API is accessible only for site admin or sales ops user.
 */
export const listTrialSkus = (options?: Options) => {
  return (options?.client ?? client).get<
    ListTrialSkusResponse,
    ListTrialSkusError
  >({
    ...options,
    url: '/trialskus',
  });
};

/**
 * Create TrialSku
 * Add a sku value into trial skus list. This API is accessible only for site admin or sales ops user.
 */
export const postTrialSku = (options: Options<PostTrialSkuData>) => {
  return (options?.client ?? client).post<
    PostTrialSkuResponse,
    PostTrialSkuError
  >({
    ...options,
    url: '/trialskus',
  });
};

/**
 * Create EcomTransaction
 * Create a transaction for activity action of required count on an entitlement.<br/>This API will work for user with site admin access as well as the transaction created by or modified by user.
 */
export const postEcomTransaction = (
  options: Options<PostEcomTransactionData>
) => {
  return (options?.client ?? client).post<
    PostEcomTransactionResponse,
    PostEcomTransactionError
  >({
    ...options,
    url: '/transactions',
  });
};

/**
 * Get skuFeatureMapping
 * Fetches all the sku feature mapping details cached in the database based on the sku and source.<br/>This API will work for user with site admin or sales ops access only.
 */
export const getSkuFeatureMapping = (
  options: Options<GetSkuFeatureMappingData>
) => {
  return (options?.client ?? client).get<
    GetSkuFeatureMappingResponse,
    GetSkuFeatureMappingError
  >({
    ...options,
    url: '/skus/{sku}/features',
  });
};

/**
 * Create skuFeatureMapping
 * Create a sku feature mapping in the ecom database.<br/>This API will work for user with site admin or sales ops access only.
 */
export const postSkuFeatureMapping = (
  options: Options<PostSkuFeatureMappingData>
) => {
  return (options?.client ?? client).post<
    PostSkuFeatureMappingResponse,
    PostSkuFeatureMappingError
  >({
    ...options,
    url: '/skus/{sku}/features',
  });
};

/**
 * Delete skuFeatureMapping
 * Deletes all the sku feature mapping cached in the database based on the sku and source.<br/>This API will work for user with site admin or sales ops access only.
 */
export const deleteSkuFeatureMapping = (
  options: Options<DeleteSkuFeatureMappingData>
) => {
  return (options?.client ?? client).delete<
    DeleteSkuFeatureMappingResponse,
    DeleteSkuFeatureMappingError
  >({
    ...options,
    url: '/skus/{sku}/features',
  });
};

/**
 * Update skuFeatureMapping
 * Update the sku feature mapping details cached in the database based on the sku, source and feature type id.<br/>This API will work for user with site admin or sales ops access only.
 */
export const updateSkuFeatureMapping = (
  options: Options<UpdateSkuFeatureMappingData>
) => {
  return (options?.client ?? client).patch<
    UpdateSkuFeatureMappingResponse,
    UpdateSkuFeatureMappingError
  >({
    ...options,
    url: '/skus/{sku}/features',
  });
};

/**
 * Create Invitation
 * Create an invitation based on account id and entitlement or project id. This API is accessible for admins of account on which the invitation is being created.
 */
export const createInvitation = (options: Options<CreateInvitationData>) => {
  return (options?.client ?? client).post<
    CreateInvitationResponse,
    CreateInvitationError
  >({
    ...options,
    url: '/invitationkeys',
  });
};

/**
 * Apply Invitation Status for User
 * Set the invitation for user by ID based on status applied
 */
export const applyInvitationKey = (
  options: Options<ApplyInvitationKeyData>
) => {
  return (options?.client ?? client).post<
    ApplyInvitationKeyResponse,
    ApplyInvitationKeyError
  >({
    ...options,
    url: '/invitationkeys/{key}/status/{status}',
  });
};

/**
 * Create Entitlement of type
 * Create an entitlement in ecom system based on type. This API is accessible for only site admin and sales ops only.<br/>Any account Id passed as input, has to be present in accounts profile service.
 */
export const createEntitlement = (options: Options<CreateEntitlementData>) => {
  return (options?.client ?? client).post<
    CreateEntitlementResponse,
    CreateEntitlementError
  >({
    ...options,
    url: '/entitlements',
  });
};

/**
 * Get Bulk Access
 * Identify the access level for the PROJECT_ACCESS type. This API is accessible for all users. Value field is mandatory for this API, which will be TC project id.<br/>Based on the user's activations fetched from EMS and ATC, the access level to requested type is returned as FULL_ACCESS or NO_ACCESS.<br/>Example: Only business users will have FULL_ACCESS to PROJECT_ACCESS on a business project id value.
 */
export const getBulkAccess = (options: Options<GetBulkAccessData>) => {
  return (options?.client ?? client).post<
    GetBulkAccessResponse,
    GetBulkAccessError
  >({
    ...options,
    url: '/check/bulk',
  });
};

/**
 * List Activations
 * Fetching all activations of the calling user.<br/>Refresh flag will trigger EMS and ATC API calls to fetch latest activations/licenses of that user. By default, refresh flag is false.<br/>If userId is present in input, the calling user has to be with site admin access to fetch the cached activations of that user. Or else, the calling user's activations are returned
 */
export const listActivations = (options?: Options<ListActivationsData>) => {
  return (options?.client ?? client).get<
    ListActivationsResponse,
    ListActivationsError
  >({
    ...options,
    url: '/activations',
  });
};

/**
 * Create User Activation
 * Create an activation for the user based on only internal type skus defined or on an entitlement already present in the ECom system. User's TIDUUID or a emailId must be given as input in the request body.<br/>This API will work for user with site admin as well as the requesting user. Only INTERNAL_TRAIL sku activation can be created by the calling user if he is not a site admin
 */
export const postUserActivation = (
  options: Options<PostUserActivationData>
) => {
  return (options?.client ?? client).post<
    PostUserActivationResponse,
    PostUserActivationError
  >({
    ...options,
    url: '/activations',
  });
};

/**
 * Create ActivationRequest for project
 * Generate an activation request based on the project Id. A user can create multiple activation request for the same project. Each request is tracked as a new entry.
 */
export const createActivationRequest = (
  options: Options<CreateActivationRequestData>
) => {
  return (options?.client ?? client).post<
    CreateActivationRequestResponse,
    CreateActivationRequestError
  >({
    ...options,
    url: '/activationrequests',
  });
};

/**
 * List accounts
 * List all accounts for site Admin. And also can search Accounts by Account name. This API can be accessed only by Site Admin
 */
export const listAccounts = (options?: Options<ListAccountsData>) => {
  return (options?.client ?? client).get<
    ListAccountsResponse,
    ListAccountsError
  >({
    ...options,
    url: '/accounts',
  });
};

/**
 * Create account
 * Create account in Account Profile Service.
 */
export const createAccount = (options: Options<CreateAccountData>) => {
  return (options?.client ?? client).post<
    CreateAccountResponse,
    CreateAccountError
  >({
    ...options,
    url: '/accounts',
  });
};

/**
 * Export users
 * Creates a job to export project users under a specified account. The response body will include job details along with the input provided. Note: This API supports a maximum of 100 User TRNs in the request body.Access to this API is restricted to **`Account Admin`** users only. To check the current status of the export job, use the [getExportDetails](#/Account%20Data%20Exports%20API/getExportDetails) API.
 */
export const exportAccountUsers = (
  options: Options<ExportAccountUsersData>
) => {
  return (options?.client ?? client).post<
    ExportAccountUsersResponse,
    ExportAccountUsersError
  >({
    ...options,
    url: '/accounts/{accountId}/export-users',
  });
};

/**
 * Export projects
 * Creates a job to export projects under a specified account. The response body will include job details along with the input provided. Note: This API supports a maximum of 100 Project TRNs in the request body. Access to this API is restricted to **`Account Admin`** users only. To check the current status of the export job, use the [getExportDetails](#/Account%20Data%20Exports%20API/getExportDetails) API.
 */
export const exportAccountProjects = (
  options: Options<ExportAccountProjectsData>
) => {
  return (options?.client ?? client).post<
    ExportAccountProjectsResponse,
    ExportAccountProjectsError
  >({
    ...options,
    url: '/accounts/{accountId}/export-projects',
  });
};

/**
 * Get Account admins
 * This API fetches account admins from EMS or ATC system based on the account Id and is accessible for those who own **`Site Admin`**, **`App Admin`** or **`Account Admin`** privileges.
 *
 * The supported source roles in Trimble Connect for EMS accounts are TCP_ACCOUNT_OWNER, TCP_SECONDARY_ACCOUNT_OWNER, TCP_COMPANY_ADMIN and the source role for ATC accounts is ADMIN.
 *
 * The **refresh** flag is an optional param and the default value is *false*.
 * * **true** - will synchronously fetch all the admins under an account using [EMS](http://trimble-digitaltechnologies-swagger.s3-website-us-east-1.amazonaws.com/#/admin/accounts/get_admin_accounts__accountId__users) or [ATC (/graph/me())](https://confluence.trimble.tools/pages/viewpage.action?spaceKey=SOS&title=ATC+REST+API) API with the active activations of each admin.
 * * **false** - will return the account admins that are cached. If there is no data in cache for this account, then the persisted account admins from the database will be returned.
 */
export const getAccountAdmins = (options: Options<GetAccountAdminsData>) => {
  return (options?.client ?? client).get<
    GetAccountAdminsResponse,
    GetAccountAdminsError
  >({
    ...options,
    url: '/accounts/{accountId}/admins',
  });
};

/**
 * Add admins in Account
 * This API is to add admins to an account using the [EMS API](http://trimble-digitaltechnologies-swagger.s3-website-us-east-1.amazonaws.com/#/admin/users/roles/post_admin_accounts__accountId__users) and this is accessible for those who own **`Site Admin`**, **`App Admin`** or **`Account Admin`** privileges. List of TIDUUIDs or a user's email address must be given as input in the request body.
 *
 * The **sourceRoles** is an optional field in the request body and the supported source roles are TCP_ACCOUNT_OWNER, TCP_SECONDARY_ACCOUNT_OWNER, TCP_COMPANY_ADMIN
 * * By default, the **EMS default role** will be assigned to all the users given in the userIds field.
 *
 * **Note:** This API is not supported for ATC accounts.
 */
export const addAccountAdmins = (options: Options<AddAccountAdminsData>) => {
  return (options?.client ?? client).post<
    AddAccountAdminsResponse,
    AddAccountAdminsError
  >({
    ...options,
    url: '/accounts/{accountId}/admins',
  });
};

/**
 * Activate account
 * This API is to assign the admin privilege for the owner of the EMS account created via Connect.
 * The user who requested an account can activate it by calling this API or the **`Site admin`** can activate the account for the user.
 *
 * Account activate API will add an admin with the *EMS default source role* in the created account using the [EMS API](http://trimble-digitaltechnologies-swagger.s3-website-us-east-1.amazonaws.com/#/admin/users/roles/post_admin_accounts__accountId__users).
 *
 * **Note:** This API is not supported for ATC accounts.
 */
export const activateAccount = (options: Options<ActivateAccountData>) => {
  return (options?.client ?? client).post<
    ActivateAccountResponse,
    ActivateAccountError
  >({
    ...options,
    url: '/accounts/{accountId}/activate',
  });
};

/**
 * Get Bulk Context Access
 * Retrieve application access and policy type information in bulk for the requested contexts. This API operates within the current user context and supports a maximum of 25 contexts per request. Currently, only project contexts are supported.
 */
export const checkContextAccessInBulk = (
  options: Options<CheckContextAccessInBulkData>
) => {
  return (options?.client ?? client).post<
    CheckContextAccessInBulkResponse,
    CheckContextAccessInBulkError
  >({
    ...options,
    url: '/access/bulk',
  });
};

/**
 * Get account details
 * Get account details from Account Profile Service. Users having invitation key under this account can access this API
 */
export const getAccountDetails = (options: Options<GetAccountDetailsData>) => {
  return (options?.client ?? client).get<
    GetAccountDetailsResponse,
    GetAccountDetailsError
  >({
    ...options,
    url: '/accounts/{accountId}',
  });
};

/**
 * Update account
 * The purpose of this API is to enable **`Site Admin`** or **`App Admin`** to modify the account name and account type.
 * These updates will be done only in Connect system and **NOT in CDH system**.
 * The account name post update will be reflected for the user within a maximum duration of 8 hours, as the data is cached.
 */
export const updateAccount = (options: Options<UpdateAccountData>) => {
  return (options?.client ?? client).patch<
    UpdateAccountResponse,
    UpdateAccountError
  >({
    ...options,
    url: '/accounts/{accountId}',
  });
};

/**
 * Get User Accounts
 * This API is to fetch the list of EMS and ATC accounts of a user and is accessible only for users with **`Site Admin`** privileges.
 *
 * The **adminRole** flag is an optional param and the default value is *true*.
 * * **true** - will fetch the cached accounts in which the user has the admin role. If there is no data in cache for this user, then the accounts that are persisted in the database will be returned.
 * * **false** - accounts in which the user has the LICENSED_USER role will be returned. **LICENSED_USER** is the role assigned to the users who do not have any admin privileges in an account and have an ACTIVE license under that account.
 *
 * **Note:**
 * * The supported source roles in Trimble Connect for EMS accounts are TCP_ACCOUNT_OWNER, TCP_SECONDARY_ACCOUNT_OWNER, TCP_COMPANY_ADMIN and the source role for the ATC accounts is ADMIN.
 * * This API will not internally call EMS or ATC APIs to get the accounts.
 */
export const getUserAccounts = (options: Options<GetUserAccountsData>) => {
  return (options?.client ?? client).get<
    GetUserAccountsResponse,
    GetUserAccountsError
  >({
    ...options,
    url: '/users/{userId}/accounts',
  });
};

/**
 * List Usages
 * Retrieve usage based on project ID.<br/>This API is accessible to users with site admin privileges.
 */
export const listUsages = (options?: Options<ListUsagesData>) => {
  return (options?.client ?? client).get<ListUsagesResponse, ListUsagesError>({
    ...options,
    url: '/usages',
  });
};

/**
 * Get TrialSku
 * Identity if a sku value is present in trial skus list. This API is accessible for all users
 */
export const getTrialSku = (options: Options<GetTrialSkuData>) => {
  return (options?.client ?? client).get<GetTrialSkuResponse, GetTrialSkuError>(
    {
      ...options,
      url: '/trialskus/{sku}',
    }
  );
};

/**
 * Delete TrialSku
 * Delete a sku value from trial skus list. This API is accessible only for site admin or sales ops user.
 */
export const deleteTrialSku = (options: Options<DeleteTrialSkuData>) => {
  return (options?.client ?? client).delete<
    DeleteTrialSkuResponse,
    DeleteTrialSkuError
  >({
    ...options,
    url: '/trialskus/{sku}',
  });
};

/**
 * List skufeaturemappings
 * List all SKUs recognised and managed in ecom system.<br/>This API will work for user with site admin or sales ops access only.
 */
export const listSkuFeatureMappings = (options?: Options) => {
  return (options?.client ?? client).get<
    ListSkuFeatureMappingsResponse,
    ListSkuFeatureMappingsError
  >({
    ...options,
    url: '/skus',
  });
};

/**
 * Get Project Entitlement
 * API to get project entitlement details by Id.
 */
export const getProjectEntitlement = (
  options: Options<GetProjectEntitlementData>
) => {
  return (options?.client ?? client).get<
    GetProjectEntitlementResponse,
    GetProjectEntitlementError
  >({
    ...options,
    url: '/projects/{projectId}/entitlements',
  });
};

/**
 * Get Project AccountDto
 * Fetch the account details of the project.
 */
export const getProjectAccountDto = (
  options: Options<GetProjectAccountDtoData>
) => {
  return (options?.client ?? client).get<
    GetProjectAccountDtoResponse,
    GetProjectAccountDtoError
  >({
    ...options,
    url: '/projects/{projectId}/accounts',
  });
};

/**
 * Get a policy by ID
 * This API returns features and applications for the given policy ID. It is only accessible for `Site Admin`.
 */
export const getPolicyById = (options: Options<GetPolicyByIdData>) => {
  return (options?.client ?? client).get<
    GetPolicyByIdResponse,
    GetPolicyByIdError
  >({
    ...options,
    url: '/policies/{policyId}',
  });
};

/**
 * List My Invitations
 * List all invitations applied by the calling user.
 */
export const listMyInvitations = (options?: Options<ListMyInvitationsData>) => {
  return (options?.client ?? client).get<
    ListMyInvitationsResponse,
    ListMyInvitationsError
  >({
    ...options,
    url: '/myinvitationkeys',
  });
};

/**
 * Fetch my Accounts
 * This API is to fetch the list of calling user's accounts from the EMS and ATC systems.
 *
 * Both **adminRole** and **refresh** flags are optional. The default value for the **adminRole** flag is *true* and for the **refresh** flag is *false*.
 *
 * |adminRole   |refresh   |Description   |
 * | --- | ---| ---|
 * | true   | false   |Fetch the cached accounts in which the user has the admin role. If there is no data in cache for the calling user, then the accounts that are persisted in the database will be returned. And the event will be published to refresh the account admins asynchronously.  |
 * | true   | true   |Fetch all the accounts in which the user has the supported admin roles using [EMS](http://trimble-digitaltechnologies-swagger.s3-website-us-east-1.amazonaws.com/#/admin/accounts/get_admin_users__userId__accounts) and [ATC (/graph/me())](https://confluence.trimble.tools/pages/viewpage.action?spaceKey=SOS&title=ATC+REST+API) APIs synchronously.  |
 * | false   | true   |User's licenses will be refreshed synchronously and the accounts in which the user has the LICENSED_USER role will be returned.**LICENSED_USER** is the role assigned to the users who do not have any admin privileges in an account and have an ACTIVE license under that account.  |
 * | false   | false   |Fetch all the accounts in which the user has the LICENSED_USER role from the database.   |
 *
 * **Note:**
 *
 * * The supported source roles in Trimble Connect for EMS accounts are TCP_ACCOUNT_OWNER, TCP_SECONDARY_ACCOUNT_OWNER, TCP_COMPANY_ADMIN and the source role for the ATC accounts is ADMIN.
 *
 * * If the **refresh** flag is *false* irrespective of the **adminRole** flag, the event will be triggered to refresh the admin accounts asynchronously.
 */
export const getMyAccounts = (options?: Options<GetMyAccountsData>) => {
  return (options?.client ?? client).get<
    GetMyAccountsResponse,
    GetMyAccountsError
  >({
    ...options,
    url: '/myaccounts',
  });
};

/**
 * Get Invitation
 * Get invitation details by key.
 */
export const getInvitation = (options: Options<GetInvitationData>) => {
  return (options?.client ?? client).get<
    GetInvitationResponse,
    GetInvitationError
  >({
    ...options,
    url: '/invitationkeys/{key}',
  });
};

/**
 * Delete Invitation
 * Expiry the invitation shared. This API is accessible for admins of account on which the invitation was created.
 */
export const deleteInvitation = (options: Options<DeleteInvitationData>) => {
  return (options?.client ?? client).delete<
    DeleteInvitationResponse,
    DeleteInvitationError
  >({
    ...options,
    url: '/invitationkeys/{key}',
  });
};

/**
 * List Users with Invitation
 * List all users to whom invitation is sent by id. This API is accessible for admins of account on which the invitation was created.
 */
export const listInvitations = (options: Options<ListInvitationsData>) => {
  return (options?.client ?? client).get<
    ListInvitationsResponse,
    ListInvitationsError
  >({
    ...options,
    url: '/invitationkeys/{key}/users',
  });
};

/**
 * Get Feature Access
 * List feature values based on the activations maintained for user.<br/> Refresh option is provided to reload the user's activations from license sources
 */
export const getFeatureAccess = (options: Options<GetFeatureAccessData>) => {
  return (options?.client ?? client).get<
    GetFeatureAccessResponse,
    GetFeatureAccessError
  >({
    ...options,
    url: '/feature/{emsFeatureId}/check',
  });
};

/**
 * Get export details by jobId
 * Fetch export job details by jobId. This API is accessible only to the user who initiated the job for the specified job ID. The result field will include the pre-signed download URL once the status is marked as DONE.
 *
 * **Optional 'include' Parameter:** A comma-separated list of fields ('result', 'input'). If specified, the response will include these fields; otherwise, they will be excluded.
 *
 * **'status' Parameter:** Specifies the job status with the following possible values:
 * - **DONE**: Export job have been processed successfully.
 * - **PROCESSING**: The job is still being processed.
 * - **QUEUED**: The job is waiting to be picked for processing.
 * - **FAILED**: The job encountered internal errors during processing.
 */
export const getExportDetails = (options: Options<GetExportDetailsData>) => {
  return (options?.client ?? client).get<
    GetExportDetailsResponse,
    GetExportDetailsError
  >({
    ...options,
    url: '/exports/{exportJobId}',
  });
};

/**
 * Get Entitlement
 * API to get entitlement details by Id and can access only by site Admin, Sales Ops and users who are mapped with the given entitlement Id. Users having invitaion key can fetch the entitlement details
 */
export const getEntitlement = (options: Options<GetEntitlementData>) => {
  return (options?.client ?? client).get<
    GetEntitlementResponse,
    GetEntitlementError
  >({
    ...options,
    url: '/entitlements/{entitlementId}',
  });
};

/**
 * Delete Entitlement by Id
 * Expire the entitlement based on id. Revoke all user activations present for this entitlement id in ecom service. This API is accessible for site admin and sales ops only.
 */
export const deleteEntitlement = (options: Options<DeleteEntitlementData>) => {
  return (options?.client ?? client).delete<
    DeleteEntitlementResponse,
    DeleteEntitlementError
  >({
    ...options,
    url: '/entitlements/{entitlementId}',
  });
};

/**
 * List Users By Entitlement Id
 * API to list users mapped with the given entitlement Id and can be accessed only by site Admin and Sales Ops
 */
export const listUsers = (options: Options<ListUsersData>) => {
  return (options?.client ?? client).get<ListUsersResponse, ListUsersError>({
    ...options,
    url: '/entitlements/{entitlementId}/users',
  });
};

/**
 * List Features By Entitlement Id
 * API to get features of the given entitlement Id and can be accessed only by site Admin, Sales Ops and users who are mapped with the given entitlement Id
 */
export const listFeatures = (options: Options<ListFeaturesData>) => {
  return (options?.client ?? client).get<
    ListFeaturesResponse,
    ListFeaturesError
  >({
    ...options,
    url: '/entitlements/{entitlementId}/usage',
  });
};

/**
 * List Projects By Entitlement Id
 * API to list Projects mapped with the given entitlement Id and can be accessed only by site Admin and Sales Ops
 */
export const listProjects = (options: Options<ListProjectsData>) => {
  return (options?.client ?? client).get<
    ListProjectsResponse,
    ListProjectsError
  >({
    ...options,
    url: '/entitlements/{entitlementId}/projects',
  });
};

export const getBlockedSku = (options: Options<GetBlockedSkuData>) => {
  return (options?.client ?? client).get<
    GetBlockedSkuResponse,
    GetBlockedSkuError
  >({
    ...options,
    url: '/block-skus/{sku}',
  });
};

/**
 * Get Activation
 * Fetch the details of the activation by id mapped to the user.
 */
export const getActivation = (options: Options<GetActivationData>) => {
  return (options?.client ?? client).get<
    GetActivationResponse,
    GetActivationError
  >({
    ...options,
    url: '/activations/{activationId}',
  });
};

/**
 * Delete Activation
 * Sets the activation of all user mapped to the input activation id as INACTIVE.<br/>This API will work for user with site admin only.
 */
export const deleteUserActivation = (
  options: Options<DeleteUserActivationData>
) => {
  return (options?.client ?? client).delete<
    DeleteUserActivationResponse,
    DeleteUserActivationError
  >({
    ...options,
    url: '/activations/{activationId}',
  });
};

/**
 * Get ActivationRequest
 * Get activation request based on Id
 */
export const getActivationRequest = (
  options: Options<GetActivationRequestData>
) => {
  return (options?.client ?? client).get<
    GetActivationRequestResponse,
    GetActivationRequestError
  >({
    ...options,
    url: '/activationrequests/{id}',
  });
};

/**
 * Get users mapped to account
 * List all users mapped with the given account id .
 */
export const getUsersInAccount = (options: Options<GetUsersInAccountData>) => {
  return (options?.client ?? client).get<
    GetUsersInAccountResponse,
    GetUsersInAccountError
  >({
    ...options,
    url: '/accounts/{accountId}/users',
  });
};

/**
 * Get user activations mapped to an account
 * Fetch the user activations mapped with the given account id and this API is accessible for account Admin
 */
export const getUserActivationsInAccount = (
  options: Options<GetUserActivationsInAccountData>
) => {
  return (options?.client ?? client).get<
    GetUserActivationsInAccountResponse,
    GetUserActivationsInAccountError
  >({
    ...options,
    url: '/accounts/{accountId}/users/{userId}',
  });
};

/**
 * Remove user from an Account
 * Remove user from an account based on the account id and user Id.
 */
export const removeAccountUser = (options: Options<RemoveAccountUserData>) => {
  return (options?.client ?? client).delete<
    RemoveAccountUserResponse,
    RemoveAccountUserError
  >({
    ...options,
    url: '/accounts/{accountId}/users/{userId}',
  });
};

/**
 * List account user projects
 * Retrieve a list of all distinct user's projects id along with the region. This API is accessible to Site Admins and Account Admins.
 */
export const listAccountUserProjects = (
  options: Options<ListAccountUserProjectsData>
) => {
  return (options?.client ?? client).get<
    ListAccountUserProjectsResponse,
    ListAccountUserProjectsError
  >({
    ...options,
    url: '/accounts/{accountId}/users/{userId}/projects',
  });
};

/**
 * Get account usage
 * Fetch usage for the given account id and this API is accessible for site admin and account Admin
 */
export const getAccountUsage = (options: Options<GetAccountUsageData>) => {
  return (options?.client ?? client).get<
    GetAccountUsageResponse,
    GetAccountUsageError
  >({
    ...options,
    url: '/accounts/{accountId}/usage',
  });
};

/**
 * Get projects mapped to account
 * List all project ids mapped with the given account id as primary.
 */
export const getProjectsInAccount = (
  options: Options<GetProjectsInAccountData>
) => {
  return (options?.client ?? client).get<
    GetProjectsInAccountResponse,
    GetProjectsInAccountError
  >({
    ...options,
    url: '/accounts/{accountId}/projects',
  });
};

/**
 * List account users
 * Retrieve a list of all unique users along with the number of projects they are associated with under the account. This API is accessible to Site Admins and Account Admins.
 */
export const listAccountUsers = (options: Options<ListAccountUsersData>) => {
  return (options?.client ?? client).get<
    ListAccountUsersResponse,
    ListAccountUsersError
  >({
    ...options,
    url: '/accounts/{accountId}/project-users',
  });
};

/**
 * Fetch account-project user mapping with activeProjectsCount.
 * Retrieve the account user mapping along with the activeProjectsCount for a specific user under the account. This API is accessible to Site Admins and Account Admins.
 */
export const fetchAccountProjectUserMapping = (
  options: Options<FetchAccountProjectUserMappingData>
) => {
  return (options?.client ?? client).get<
    FetchAccountProjectUserMappingResponse,
    FetchAccountProjectUserMappingError
  >({
    ...options,
    url: '/accounts/{accountId}/project-users/{userId}',
  });
};

/**
 * List Invitations under Account
 * List all invitations created under an account. This API is accessible for admins of account in Account Profile Service.
 */
export const listAccountInvitations = (
  options: Options<ListAccountInvitationsData>
) => {
  return (options?.client ?? client).get<
    ListAccountInvitationsResponse,
    ListAccountInvitationsError
  >({
    ...options,
    url: '/accounts/{accountId}/invitationkeys',
  });
};

/**
 * List Entitlements By Account Id
 * API to list entitlements mapped with the given Account Id and can be accessed only by site Admin and Sales Ops
 */
export const listEntitlements = (options: Options<ListEntitlementsData>) => {
  return (options?.client ?? client).get<
    ListEntitlementsResponse,
    ListEntitlementsError
  >({
    ...options,
    url: '/accounts/{accountId}/entitlements',
  });
};

/**
 * List Activation Request under Account
 * List all activation requests under an account. This API is accessible for account admin alone.
 */
export const listActivationRequest = (
  options: Options<ListActivationRequestData>
) => {
  return (options?.client ?? client).get<
    ListActivationRequestResponse,
    ListActivationRequestError
  >({
    ...options,
    url: '/accounts/{accountId}/activationrequests',
  });
};

/**
 * Get Access Policy
 * This API retrieves the access policy based on the provided context. In the absence of a context, it defaults to USER, allowing the API to fetch the access policy at the user level
 */
export const getAccessPolicy = (options?: Options<GetAccessPolicyData>) => {
  return (options?.client ?? client).get<
    GetAccessPolicyResponse,
    GetAccessPolicyError
  >({
    ...options,
    url: '/access-policy',
  });
};

/**
 * Remove Account admins
 * Remove account admin based on the account id and user Id.
 */
export const removeAccountAdmins = (
  options: Options<RemoveAccountAdminsData>
) => {
  return (options?.client ?? client).delete<
    RemoveAccountAdminsResponse,
    RemoveAccountAdminsError
  >({
    ...options,
    url: '/accounts/{accountId}/admins/{adminId}',
  });
};
